/* ================================================================
   MAGNA PLAN SELECTOR — JavaScript
   File: assets/magna-plan-selector.js
================================================================ */
(function () {
  'use strict';

  function initPlanSelector(root) {
    var plans = root.querySelectorAll('.mps__plan');
    var sectionId = root.id;

    /* ── SELECT PLAN ── */
    function selectPlan(targetPlan) {
      plans.forEach(function (p) {
        var isTarget = p === targetPlan;
        p.classList.toggle('mps__plan--selected', isTarget);

        var radio = p.querySelector('.mps__radio');
        if (radio) {
          radio.classList.toggle('mps__radio--checked', isTarget);
        }

        /* Show/hide flavor picker based on plan setting */
        var fp = p.querySelector('.mps__flavors');
        if (fp) {
          fp.style.display = isTarget ? '' : 'none';
        }
      });
    }

    /* ── PLAN CLICK ── */
    plans.forEach(function (plan) {
      plan.addEventListener('click', function (e) {
        /* Don't re-trigger if clicking a flavor pill */
        if (e.target.closest('.mps__flavor-pill')) return;
        selectPlan(plan);
      });
    });

    /* ── FLAVOR PILL CLICK ── */
    root.querySelectorAll('.mps__flavors-grid').forEach(function (grid) {
      var pills = grid.querySelectorAll('.mps__flavor-pill');
      pills.forEach(function (pill) {
        pill.addEventListener('click', function (e) {
          e.stopPropagation();
          pills.forEach(function (p) { p.classList.remove('mps__flavor-pill--selected'); });
          pill.classList.add('mps__flavor-pill--selected');

          /* Also select the parent plan */
          var parentPlan = pill.closest('.mps__plan');
          if (parentPlan) selectPlan(parentPlan);

          /* Dispatch custom event for other sections (e.g. cart integration) */
          root.dispatchEvent(new CustomEvent('mps:flavor-selected', {
            bubbles: true,
            detail: { flavor: pill.dataset.flavor, sectionId: sectionId }
          }));
        });
      });
    });

    /* Apply CSS vars from inline style dynamically */
    function applyLayout() {
      var inner = root.querySelector('.mps__inner');
      if (!inner) return;
      inner.style.setProperty('--mps-gap', (root.dataset.gap || '8') + 'px');
    }

    applyLayout();
  }

  /* ── INIT ALL INSTANCES ON PAGE ── */
  function init() {
    document.querySelectorAll('.mps').forEach(function (root) {
      initPlanSelector(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ── SHOPIFY THEME EDITOR LIVE RELOAD ── */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.mps');
    if (root) initPlanSelector(root);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('.mps');
    if (root) initPlanSelector(root);
  });

})();
